export default __webpack_public_path__ + "locales/fi/ChangePasswordDialog.json?hash=e898656878bf81ebff48afeb09e9b12d";